export const subTotal = (quantity, price) => {
  return quantity * price;
};
